<asg-floating-menu [menuItem]="AsgardFeatureNames.DRAWING_TOOLS">
  <ul>
    <li [ngClass]="{ active: isShapeActive(PdfToolType.Rectangle),
      'disabled': uiState && uiState[AsgardFeatureNames.DRAW_RECT].disabled }"
      (click)="toggleShapeType(PdfToolType.Rectangle)" asgTooltip="TOOLBARS.DRAW_RECT">
      <i class="far fa-square-full"></i>
    </li>
    <li
      [ngClass]="{ active: isShapeActive(PdfToolType.Ellipse), 'disabled': uiState && uiState[AsgardFeatureNames.DRAW_CIRCLE].disabled }"
      (click)="toggleShapeType(PdfToolType.Ellipse)" asgTooltip="TOOLBARS.DRAW_CIRCLE">
      <i class="far fa-circle"></i>
    </li>
    <li
      [ngClass]="{ active: isShapeActive(PdfToolType.Arrow), 'disabled': uiState && uiState[AsgardFeatureNames.DRAW_ARROW].disabled }"
      (click)="toggleShapeType(PdfToolType.Arrow)" asgTooltip="TOOLBARS.DRAW_ARROW">
      <i class="far fa-long-arrow-right"></i>
    </li>
    <li
      [ngClass]="{ active: isShapeActive(PdfToolType.Line), 'disabled': uiState && uiState[AsgardFeatureNames.DRAW_STR_LINE].disabled }"
      (click)="toggleShapeType(PdfToolType.Line)" asgTooltip="TOOLBARS.DRAW_STR_LINE">
      <i class="fas fa-slash diagonal"></i>
    </li>
    <li
      [ngClass]="{ active: isShapeActive(PdfToolType.FreeHand), 'disabled': uiState && uiState[AsgardFeatureNames.DRAW_LINE].disabled }"
      (click)="toggleShapeType(PdfToolType.FreeHand)" asgTooltip="TOOLBARS.DRAW_LINE">
      <i class="fas fa-pencil"></i>
    </li>
    <mat-divider></mat-divider>
    <li class="floating-menu-toolbar--has-dropdown" asgTooltip="TOOLBARS.SELECT_DRAWING_COLOR">
      <i class="fas fa-tint" [ngStyle]="{ 'color': strokeColorValue }"></i>
      <ul class="floating-menu-toolbar__dropdown choose-color">
        @for (strokeColor of strokeColors; track strokeColor) {
          <li (click)="colorSelected(strokeColor)"
          [ngStyle]="{ 'background-color': strokeColor }" [ngClass]="{ active: strokeColorValue === strokeColor }"></li>
        }
      </ul>
    </li>
    <li class="floating-menu-toolbar--has-dropdown" asgTooltip="TOOLBARS.SELECT_DRAWING_SIZE">
      {{ strokeThicknessValue }} pt
      <ul class="floating-menu-toolbar__dropdown choose-thickness">
        @for (strokeThickness of strokeThicknessStyles; track strokeThickness) {
          <li
            (click)="strokeThicknessSelected(strokeThickness.value)"
            [ngClass]="{ active: strokeThicknessValue === strokeThickness.value }">
            <span>{{ strokeThickness.title }}</span>
            <hr [ngClass]="strokeThickness.class" />
          </li>
        }
      </ul>
    </li>

    <mat-divider></mat-divider>

    @if (hasActiveTab) {
      <li (click)="toggleAnnotationsVisibility()">
        @if (annotationsVisible) {
          <i class="fas fa-eye" asgTooltip="TOOLBARS.HIDE_DRAWING_ANNOTATIONS"></i>
        }
        @if (!annotationsVisible) {
          <i class="fas fa-eye-slash" asgTooltip="TOOLBARS.SHOW_DRAWING_ANNOTATIONS"></i>
        }
      </li>
    }
  </ul>
</asg-floating-menu>